// extracted by mini-css-extract-plugin
export var card = "_6t-0";
export var failedIcon = "_6t-4";
export var failedIconBadge = "_6t-3";
export var icon = "_6t-1";
export var successIcon = "_6t-2";